'use strict';

require('../app.js');
require('./app.js');
require('../models/invoice.js');
require('../models/account.js');
require('../collections/invoices.js');
require('../../../modules/data/adminInvoices.js');
require('../account/widgets/invoices.js');
require('../account/curations/invoices.js');
